export const Services = [
  {
    id: "1",
    title: "Sekcyjna ścinka drzew",
    content:
      "Gdy zajdzie konieczność usunięcia drzewa na terenie mocno zurbanizowanym ścinka sekcyjna często stanowi jedyne rozwiązanie. ",
    photo: "Images/sekcyjne.jpg",
  },
  {
    id: "2",
    title: "Prace pielęgnacyjne",
    content:
      "Większość drzew na terenach zurbanizowanych wymaga regularnego zmniejszania gęstości korony, aby zapobiec ich uszkodzeniom spowodowanych np. przez wiatr. W tej technice usuwamy drobne, niechciane gałęzie, aby stworzyć silną sieć grubych konarów. ",
    photo: "Images/pielegnacja.jpg",
  },
  {
    id: "3",
    title: "Korekcja korony ",
    content:
      "Korekcja korony jest często konieczna, gdy drzewo staje się zbyt duże i zaczyna kolidować z budynkami lub liniami napowietrznymi. Zabieg ten stosowany jest również w celu poprawy statyki drzewa i często jest alternatywą wycinki.",
    photo: "Images/nr1.jpg",
  },
  {
    id: "4",
    title: "Wiązania elastyczne",
    content:
      "Zabezpieczenie koron drew polega na powiązaniu wielopniowych koron z V kształtnymi rozgałęzieniami specjalnymi  linami syntetycznymi. . Umożliwia to zabezpieczenie drzewa przed rozłamaniem i jest alternatywą dla usuwania grubych gałęzi, których usuniecie negatywnie wpłynęłoby na żywotność drzewa. Niejednokrotnie jest jedynym rozwiązaniem na zabezpieczenie drzew w sędziwym wieku. ",
    photo: "Images/elastyczne.jpg",
  },
  {
    id: "5",
    title: "Airs-spade",
    content:
      "Air Spade to urządzenie, dzięki któremu możliwe jest wykonanie rozluźnienie oraz napowietrzenie struktury gleby, przy wykorzystaniu strumienia sprężonego powietrza, przeznaczony jest do wykonywania prac ziemnych, również w obrębie systemów korzeniowych drzew, Praca z Air Spade to najmniej inwazyjna metoda.",
    photo: "Images/airspade.jpg",
  },
  {
    id: "6",
    title: "Frezowanie Pni",
    content:
      "Frezowanie pni umożliwia całkowite usuniecie kłopotliwego pnia pozostałego po wycięciu drzewa. W warunkach naturalnych rozkład pnia zajmuję od 5-10 lat. Frezując pień możemy cieszyć się czystym, równym trawnikiem niemal natychmiast.",
    photo: "Images/frezowanie.jpg",
  },
  {
    id: "7",
    title: "Mielenie gałęzi",
    content:
      "Oferujemy mielenie gałęzi po wycince lub pracach ogrodowych oraz utylizacje biomasy.",
    photo: "Images/mielenie.jpg",
  },
  {
    id: "8",
    title: "Alpinizm przemysłowy",
    content:
      "Gdy nie pracujemy na drzewach zajmujemy się pracą na wysokości. Docieramy wszędzie tam gdzie niezbędny jest dostęp linowy.",
    photo: "Images/alpinizm.jpg",
  },
  {
    id: "9",
    title: "Inne",
    content:
      "Czyszczenie i utrzymanie terenów zielonych, Sadzenie drzew i krzewów, Koszenie nieużytków ",
    photo: "Images/inne.jpg",
  },
  {
    id: "10",
    title: "Frezowanie Pni",
    content:
      "Frezowanie pni umożliwia całkowite usuniecie kłopotliwego pnia pozostałego po wycięciu drzewa. W warunkach naturalnych rozkład pnia zajmuję od 5-10 lat. Frezując pień możemy cieszyć się czystym, równym trawnikiem niemal natychmiast.",
    photo: "Images/frezowanie.jpg",
  },
];
